<template>
    <NuxtLink :to="item.url" class="text-over-image" @click.native="sendToExternal">
        <img loading="lazy" :src="item.image" />
        <div class="tint"></div>
        <h3 v-html="item.title"></h3>
    </NuxtLink>
</template>

<script setup>
    const props = defineProps({
        item: {
            type: Object,
            required: true,
            default: {
                title: 'Here',
            },
        },
    });

    const route = useRoute();
    const isFramed = ref(route.path.includes('iframe'));

    const sendToExternal = (ev) => {
        if (ev.currentTarget && ev.currentTarget.tagName === 'A') {
            const href = ev.currentTarget.getAttribute('href');
            if (isFramed.value) {
                window.parent.postMessage({ type: 'navigateTo', href: href }, '*');
                ev.preventDefault();
                return false;
            }
        }
        return true;
    };
</script>

<style lang="scss">
    .text-over-image {
        z-index: 0;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        padding-top: 100%;

        img,
        .tint {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }

        .tint {
            z-index: 1;
            background-color: rgba(0, 0, 0, 0.4);
        }

        h3 {
            z-index: 2;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;

            color: $white;
            font-size: 18px;
            font-family: $title;
            font-weight: 700;
            letter-spacing: 0.05em;
            text-align: center;
            text-transform: uppercase;
        }
    }
</style>
